<section class="flex flex-col h-screen pb-[22rem]">
    <div class="flex flex-col gap-3 p-4 overflow-auto">
        @for (item of items(); track $index) {
            <app-document-box-accordian [open]="false" [title]="item.month">
                <div class="flex flex-col gap-3">
                    @for (schedule of item.items; track $index) {
                        <app-schedule-log-item [schedule]="schedule" />
                    }
                </div>
            </app-document-box-accordian>
        }
    </div>
</section>
